module.exports = __webpack_public_path__ + "img/semconexao.b87f8e97.png";